import ConfirmationModalSystem from './ConfirmationModalSystem';
import './ConfirmationModalSystem.scss';

export default ConfirmationModalSystem;
